import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import * as layouts from "../../GramLayouts";

import homedata from "../../gramdata/Homepage";
import { setCurrentGram } from "../../redux/action/utilActions";
import { useDispatch, useSelector } from "react-redux";
import AddPanchayatBtn from "../../components/Buttons/AddpanchyatBtn";
import GetPageData from "../../hooks/GetPageData";
import LoadingComponet from "../../components/Loading/LoadingComponet";

const useStyles = makeStyles((theme) => ({
  root: {
    // width: "100vw",
    // backgroundColor: "red",
    [theme.breakpoints.down("md")]: {
      // backgroundColor: "white",
    },
  },
}));

const GramHome = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const gramId = useSelector((state) => state.util.currentGramId);
  const { ready, data, error } = GetPageData(`gramHome/${gramId}`);

  // console.log("pagedata", data);

  return ready && data ? (
    <div className={classes.root}>
      {/* <AddPanchayatBtn /> */}
      {data?.data?.map((data, index) => {
        const Layout = layouts[data?.layout];
        return <Layout key={index} data={data} />;
      })}
    </div>
  ) : (
    <LoadingComponet />
  );
};
export default GramHome;
